// 此 bus 仅用于 kuJSSDK 与 ku 之间的通信
import EventEmitter from 'events';

const kuJSSDKEventBus = new EventEmitter();
export default kuJSSDKEventBus;

export const INIT_READY = 'initReady';
export const OPEN_DOC_READY = 'openDocReady';

export const DOC_PUBLISH = 'docPublish';
export const NEW_DOC_VERSION = 'newDocVersion';
